import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { isValidCron } from 'cron-validator/lib';

@Directive({
  selector: '[homepageCronValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: HomepageCronValidatorDirective, multi: true },
  ],
})
export class HomepageCronValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control?.value;
    // Empty values are handled by the `required` validator, not our concern.
    if (value == null || value === '') {
      return null;
    }
    // Enforce 6-field Quartz format (matches the dropdown presets and what
    // the backend scheduler accepts). Quartz requires exactly one of
    // day-of-month (pos 4) and day-of-week (pos 6) to be '?', so accept '?'
    // in either position. 5-field crontab-style expressions and 6-field
    // expressions without '?' anywhere are rejected.
    const parts = String(value).trim().split(/\s+/);
    if (parts.length !== 6 || (parts[3] !== '?' && parts[5] !== '?')) {
      return { homepageCronValidator: true };
    }
    const isValid = isValidCron(value, {
      seconds: true,
      allowBlankDay: true,
      alias: true,
    });
    return isValid ? null : { homepageCronValidator: true };
  }
}
